import { type PersonalizedProductAccess } from "@forento/shared/models/product"
import { toPriceString } from "@forento/shared/utilities/currency"

import { type useTranslation } from "~/translations"

type T = ReturnType<typeof useTranslation>
type GetProductPriceLabelResult = { color: "orange" | "blue"; value: string }
export function getProductPriceLabel(product: PersonalizedProductAccess, t: T): GetProductPriceLabelResult {
	if (product.status === "unlocked") {
		if (product.unlockedCause === "purchased" || product.unlockedCause === "membership") {
			return { color: "blue", value: t("product.owned") }
		}
	}
	if (product.status === "paywall") {
		return { color: "orange", value: toPriceString(product.price) }
	}
	if (product.status === "membership-required") {
		return { color: "orange", value: t("membership.title") }
	}
	return { color: "orange", value: t("product.priceFree") }
}
